import Icon from './Icon'

const CloseIcon = (props) => (
  <Icon iconName="icon-close" size={16} {...props}>
    <path d="M2.784 2.089a.5.5 0 0 0-.638.765L7.293 8l-5.147 5.146-.057.07a.5.5 0 0 0 .765.638L8 8.707l5.146 5.147.07.057a.5.5 0 0 0 .638-.765L8.707 8l5.147-5.146.057-.07a.5.5 0 0 0-.765-.638L8 7.293 2.854 2.146l-.07-.057Z"></path>
  </Icon>
)

export default CloseIcon
